import React, { memo } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

import TicketLoading from './ticket-loading';
import { useParams } from 'react-router-dom';
import { ticketLoadingSelector, useAppSelector } from '../../../app/store';

const NoTicket = () => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <Box sx={{ textAlign: 'center' }}>
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        mx: 'auto',
                        mb: 1.5,
                        borderRadius: '50%',
                        display: 'grid',
                        placeItems: 'center',
                        bgcolor: 'action.hover',
                        color: 'text.secondary',
                    }}>
                    <i className="fa-light fa-triangle-exclamation" />
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: 16 }}>
                    خطا در ارتباط با سیستم
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                    دریافت اطلاعات تیکت با مشکل روبه‌رو شد.
                </Typography>
            </Box>
        </Box>
    );
};

export default memo(NoTicket);

export function NoTicketMain({ routing }: { routing?: string }) {
    const { ticketId } = useParams();
    const ticketLoading = useAppSelector(ticketLoadingSelector);

    return (
        <Card
            variant="outlined"
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                overflow: 'hidden',
                flexDirection: 'column',
                flexGrow: 1,
                justifyContent: 'center',
                alignItems: 'center',
                borderColor: 'divider',
                borderRadius: 3,
                bgcolor: 'background.paper',
            }}>
            <CardContent
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}>
                {!ticketId ? (
                    <>
                        <img
                            src="/images/no-exist.png"
                            style={{ width: '88px', marginBottom: '14px' }}
                            alt="no data"
                        />
                        <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                            یک تیکت را انتخاب کنید
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                mt: 0.5,
                                width: '100%',
                                maxWidth: 360,
                                mx: 'auto',
                                textAlign: 'center',
                                lineHeight: 1.9,
                            }}>
                            برای مشاهده گفتگو و پاسخ‌ها، یکی از تیکت‌های فهرست را انتخاب کنید.
                        </Typography>
                    </>
                ) : ticketLoading ? (
                    <TicketLoading />
                ) : (
                    <NoTicket />
                )}
            </CardContent>
        </Card>
    );
}
